import AllDealerships from './components/all-dealerships'

export default AllDealerships
